/* eslint-disable no-template-curly-in-string */
export default {
  booking: {
    scoreLabel: ['ミッション達成率'],
    scoreStatus: {
      success: ['ミッションクリア!'],
      fail: ['ミッション失敗…']
    },
    average: ['現在の平均成功率'],
    rankLabel: ['あなたの順位'],
    rank: ['上位${rank}%以内'],
    hints: ['ヒント使用回数'],
    wrongAnswers: ['誤答数'],
    counter: ['${count}回'],
    answers: ['謎と解答を見る'],
    items: ['アイテム']
  }
};
